
import CurrencyMixin from '@/mixins/currency'

export default {
  mixins: [CurrencyMixin],
  props: {
    range: {
      type: Object,
      default() {
        return {
          min: 0,
          max: 200,
        }
      },
    },
    step: {
      type: Number,
      default: 0,
    },
    defalt: {
      type: Object,
      default() {
        return {
          min: 0,
          max: 5000,
        }
      },
    },
  },

  data() {
    return {
      input: {
        min: '',
        max: '',
      },
    }
  },

  computed: {
    placeholderMin() {
      return `${this.currentCurrencyIcon() + this.$t('search.filter.price.min')}`
    },
    placeholderMax() {
      return `${this.currentCurrencyIcon() + this.$t('search.filter.price.max')}`
    },
  },

  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      let charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    reset() {
      this.input.min = ''
      this.input.max = ''
    },
    submitRange() {
      this.$emit('submit', this.input)
    },
  },
}
